export enum CefiServices {
  CARD = "card",
  STAKING = "staking",
}
